$(document).ready(function () {
  let flashHideTimeout;

  function parseIntegerQty(value, fallback) {
    const parsed = parseInt(String(value).replace(/[^\d]/g, ""), 10);
    return isNaN(parsed) ? fallback ?? 0 : parsed;
  }

  function getAmountInputBounds($input) {
    const min = parseInt($input.attr("min"), 10);
    const max = parseInt($input.attr("max"), 10);
    return {
      min: isNaN(min) ? 0 : min,
      max: isNaN(max) ? 50 : max,
    };
  }

  function normalizeAmountInput($input) {
    const { min, max } = getAmountInputBounds($input);
    const normalized = Math.min(max, Math.max(min, parseIntegerQty($input.val(), min)));
    $input.val(normalized);
    return normalized;
  }

  function updateAtcFeedbackChip(productId, html) {
    $(".product-box__cart_" + productId).each(function () {
      let $host = $(this).find(".atc-feedback-chip-host");
      if (!$host.length) {
        $host = $(
          '<div class="atc-feedback-chip-host tw-pointer-events-auto tw-absolute tw-z-20 tw-flex tw-justify-center" style="left: 0; width: 100%; top: -40px;"></div>'
        );
        $(this).find(".amount-container").prepend($host);
      }

      if (html && String(html).trim()) {
        $host.html(html);
      } else {
        $host.empty();
      }
    });
  }

  function getProductContextFromAmountInput($input) {
    const $row = $input.closest('[data-cart-product-id], [class*="product-box__cart_"]');
    let productId = $input.data("product-id") || $row.data("cart-product-id");

    if (!productId && $row.length) {
      const match = ($row.attr("class") || "").match(/product-box__cart_(\d+)/);
      productId = match ? match[1] : null;
    }

    const updateRoute =
      $input.data("update-route") ||
      $row.find(".btn-increase, .btn-decrease").first().data("route");
    const container = $row.length ? $row : $(".product-box__cart_" + productId);

    return { productId, updateRoute, container, $row };
  }

  function updateCartGlobals(response) {
    if (response.cart_total) {
      $(".cart-total").text(response.cart_total);
    }

    $(".cart-count").text(response.cart_count);

    if (response.overview) {
      $(".cart-preview__content").html(response.overview);
    }

    $(".cart-main").text(response.main);
    $(".cart-sub").text(response.sub);
  }

  function showCartFlash(response) {
    if (!response.flash) {
      return;
    }

    const $flashMessage = $(".cart-preview__flash-message");
    $flashMessage
      .html(response.flash)
      .removeClass("tw-hidden")
      .stop(true, true)
      .css("opacity", 1)
      .show();

    clearTimeout(flashHideTimeout);
    flashHideTimeout = setTimeout(() => {
      $flashMessage.fadeOut(300, function () {
        $(this).addClass("tw-hidden").css({ display: "", opacity: "" });
      });
    }, 2000);
  }

  // Toggle the product-detail add-to-cart button vs. quantity stepper.
  // Scoped to elements that only exist in the detail/quick-view markup,
  // so listing pages (home, category) are unaffected.
  function toggleDetailAtcState(container, quantity) {
    const $addButton = container.find(".detail-atc-add");
    if (!$addButton.length) {
      return;
    }

    const $stepper = container.find(".detail-atc-stepper");

    if (quantity > 0) {
      // Restore the stepper's filled state, since a prior decrease-to-zero
      // may have collapsed it via the shared listing-page logic.
      $stepper
        .find(".tw-rounded-full")
        .removeClass("tw-hidden")
        .addClass("tw-bg-ds-neutral-5/95 tw-shadow-md");
      $stepper.find(".btn-decrease").removeClass("tw-hidden");
      $stepper.find(".tw-flex-1").removeClass("tw-hidden");
      $stepper
        .find(".btn-add-to-cart")
        .removeClass("btn-add-to-cart")
        .addClass("btn-increase");

      $addButton.addClass("tw-hidden");
      $stepper.removeClass("tw-hidden");
    } else {
      $stepper.addClass("tw-hidden");
      $addButton.removeClass("tw-hidden");
    }
  }

  function applyCartUpdateResponse(response, productId, container) {
    if (!response.success) {
      return;
    }

    const updatedQty = response.quantity;

    $('[data-tid="product-box__amount"][data-product-id="' + productId + '"]').each(
      function () {
        const $amountInput = $(this);
        $amountInput.val(updatedQty);
        $amountInput.data("last-qty", updatedQty);
      }
    );

    container.find('input[type="number"]').val(updatedQty);
    $(".btn-increase[data-product-id='" + productId + "']").data(
      "current-qty",
      updatedQty
    );
    $('.btn-decrease[data-product-id="' + productId + '"]').data(
      "current-qty",
      updatedQty
    );

    if (updatedQty === 0) {
      container.find(".tw-rounded-full").removeClass("tw-bg-ds-neutral-5/95 tw-shadow-md");
      container.find(".btn-decrease").addClass("tw-hidden");
      container.find(".tw-flex-1").addClass("tw-hidden");
      container.find(".btn-increase")
        .removeClass("btn-increase")
        .addClass("btn-add-to-cart");
    } else {
      container
        .find(".tw-rounded-full")
        .removeClass("tw-hidden")
        .addClass("tw-bg-ds-neutral-5/95 tw-shadow-md");
      container.find(".btn-decrease").removeClass("tw-hidden");
      container.find(".tw-flex-1").removeClass("tw-hidden");
      container.find(".btn-add-to-cart")
        .removeClass("btn-add-to-cart")
        .addClass("btn-increase");
    }

    toggleDetailAtcState(container, updatedQty);

    updateCartGlobals(response);

    if (response.atc_feedback !== undefined) {
      updateAtcFeedbackChip(productId, response.atc_feedback);
    } else if (updatedQty === 0) {
      updateAtcFeedbackChip(productId, "");
    }
  }

  function setCartLoadingState(container, isLoading) {
    const $spinners = container.find(".loading-spinner");

    $spinners.each(function () {
      const $spinner = $(this);
      const $host = $spinner.parent();

      $spinner.toggleClass("is-active", isLoading).attr("aria-hidden", isLoading ? "false" : "true");
      $host.toggleClass("is-cart-loading", isLoading);
    });
  }

  function requestCartQuantityUpdate(productId, newQty, updateRoute, container, $input, $trigger) {
    $.ajax({
      url: updateRoute,
      type: "GET",
      data: {
        rowId: productId,
        qty: newQty,
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      beforeSend: function () {
        if ($input) {
          $input.prop("disabled", true);
        }
        if ($trigger) {
          $trigger.prop("disabled", true);
        }

        setCartLoadingState(container, true);
      },
      success: function (response) {
        applyCartUpdateResponse(response, productId, container);
      },
      error: function (xhr) {
        if ($input) {
          const lastQty = parseInt($input.data("last-qty"), 10) || 0;
          $input.val(lastQty);
        }

        if (xhr.responseJSON && xhr.responseJSON.message) {
          alert(xhr.responseJSON.message);
        } else if (xhr.status === 400) {
          alert("Unable to update cart. Please check the requirements.");
        }
      },
      complete: function () {
        if ($input) {
          $input.prop("disabled", false);
        }
        if ($trigger) {
          $trigger.prop("disabled", false);
        }

        setCartLoadingState(container, false);
      },
    });
  }

  // Restrict amount input to whole numbers only
  $(document).on("keydown", '[data-tid="product-box__amount"]:not([readonly])', function (e) {
    if ([".", ",", "e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  });

  $(document).on("input", '[data-tid="product-box__amount"]:not([readonly])', function () {
    const $input = $(this);
    const sanitized = String($input.val()).replace(/[^\d]/g, "");

    if ($input.val() !== sanitized) {
      $input.val(sanitized);
    }
  });

  $(document).on("focus", '[data-tid="product-box__amount"]:not([readonly])', function () {
    const $input = $(this);
    $input.data("last-qty", parseIntegerQty($input.val(), 0));
  });

  $(document).on("blur", '[data-tid="product-box__amount"]:not([readonly])', function () {
    const $input = $(this);
    const lastQty = parseInt($input.data("last-qty"), 10) || 0;
    const newQty = normalizeAmountInput($input);

    if (newQty === lastQty) {
      return;
    }

    const cartForm = $input.closest("form.woocommerce-cart-form");
    if (cartForm.length) {
      cartForm.submit();
      return;
    }

    const { productId, updateRoute, container } = getProductContextFromAmountInput($input);

    if (!productId || !updateRoute) {
      $input.val(lastQty);
      return;
    }

    $input.data("last-qty", newQty);
    requestCartQuantityUpdate(productId, newQty, updateRoute, container, $input);
  });

  // Add to cart (increase quantity)
  $(document).on("click", ".btn-add-to-cart", function (e) {
    e.preventDefault();

    const button = $(this);
    const productId = button.data("product-id");
    var container = $(".product-box__cart_" + productId);

    $.ajax({
      url: button.data("url"),
      type: "GET",
      data: {
        id: productId,
        qty: 1,
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      beforeSend: function () {
        button.prop("disabled", true);
        setCartLoadingState(container, true);
      },
      success: function (response) {
        if (response.success) {
          const newQty = response.quantity;

          container.find('input[type="number"]').val(newQty);
          button.data("current-qty", newQty);
          $(".btn-increase[data-product-id='" + productId + "']").data(
            "current-qty",
            newQty
          );

          if (newQty > 0) {
            container
              .find(".tw-rounded-full")
              .removeClass("tw-hidden")
              .addClass("tw-bg-ds-neutral-5/95 tw-shadow-md");
            container.find(".btn-decrease").removeClass("tw-hidden");
            container.find(".tw-flex-1").removeClass("tw-hidden");
          }

          container.find('[data-tid="product-box__amount"]').val(newQty);

          updateCartGlobals(response);

          if (response.atc_feedback !== undefined) {
            updateAtcFeedbackChip(productId, response.atc_feedback);
          }

          showCartFlash(response);
        } else {
          alert(response.message || "Unable to add product to cart.");
        }
      },
      error: function (xhr) {
        if (xhr.responseJSON && xhr.responseJSON.message) {
          alert(xhr.responseJSON.message);
        } else if (xhr.status === 400) {
          alert("Unable to add product to cart. Please check the requirements.");
        }
      },
      complete: function () {
        button.removeClass("btn-add-to-cart").addClass("btn-increase");
        button.prop("disabled", false);
        setCartLoadingState(container, false);
      },
    });
  });

  // Add to cart from the product-detail / quick-view page.
  // Unlike listing pages, the detail layout keeps a dedicated wide
  // "add to cart" button and a separate quantity stepper, so we toggle
  // between the two instead of morphing a single control.
  $(document).on("click", ".btn-detail-add-to-cart", function (e) {
    e.preventDefault();

    const button = $(this);
    const productId = button.data("product-id");
    const container = $(".product-box__cart_" + productId);

    $.ajax({
      url: button.data("url"),
      type: "GET",
      data: {
        id: productId,
        qty: 1,
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      beforeSend: function () {
        button.prop("disabled", true);
        setCartLoadingState(container, true);
      },
      success: function (response) {
        if (!response.success) {
          alert(response.message || "Unable to add product to cart.");
          return;
        }

        const newQty = response.quantity;

        container.find('input[type="number"]').val(newQty);
        container.find('[data-tid="product-box__amount"]').val(newQty);
        container
          .find(".btn-increase, .btn-decrease")
          .data("current-qty", newQty);

        // Sync any listing-style boxes for this product (e.g. the card
        // behind an open quick-view popup) to the filled stepper state.
        if (newQty > 0) {
          container
            .find(".tw-rounded-full")
            .removeClass("tw-hidden")
            .addClass("tw-bg-ds-neutral-5/95 tw-shadow-md");
          container.find(".btn-decrease").removeClass("tw-hidden");
          container.find(".tw-flex-1").removeClass("tw-hidden");
          container
            .find(".btn-add-to-cart")
            .removeClass("btn-add-to-cart")
            .addClass("btn-increase");
        }

        toggleDetailAtcState(container, newQty);

        updateCartGlobals(response);

        if (response.atc_feedback !== undefined) {
          updateAtcFeedbackChip(productId, response.atc_feedback);
        }

        showCartFlash(response);
      },
      error: function (xhr) {
        if (xhr.responseJSON && xhr.responseJSON.message) {
          alert(xhr.responseJSON.message);
        } else if (xhr.status === 400) {
          alert("Unable to add product to cart. Please check the requirements.");
        }
      },
      complete: function () {
        button.prop("disabled", false);
        setCartLoadingState(container, false);
      },
    });
  });

  // Decrease or Increase quantity or remove from cart
  $(document).on("click", ".btn-decrease, .btn-increase", function (e) {
    e.preventDefault();

    const button = $(this);
    const productId = button.data("product-id");
    const row = button.closest(
      '.product-box__cart_' + productId + ', [data-cart-product-id="' + productId + '"]'
    );
    const amountInput = row.find('[data-tid="product-box__amount"]');
    const currentQty = amountInput.length
      ? parseInt(amountInput.val(), 10) || 0
      : parseInt(button.data("current-qty"), 10) || 0;
    const isIncrease = button.hasClass("btn-increase");
    const newQty = isIncrease ? currentQty + 1 : Math.max(0, currentQty - 1);
    var container = row.length ? row : $(".product-box__cart_" + productId);

    requestCartQuantityUpdate(
      productId,
      newQty,
      button.data("route"),
      container,
      null,
      button
    );
  });

  // Show cart details on hover
  $(document).on("mouseenter", ".cart-preview", function () {
    var $this = $(this);
    var $icon = $this.find(".ds-icon");

    $this.css({
      height: "calc(-121px + 100vh)",
    });

    $icon.addClass("tw-translate-y-0.5 -tw-scale-y-100");

    $(".cart-preview__content, .cart-preview__footer").removeClass("tw-hidden");
    $(".cart-preview-header").addClass("cart-preview-header--open");
  });

  // Hide cart details on mouse leave
  $(document).on("mouseleave", ".cart-preview", function () {
    var $this = $(this);
    var $icon = $this.find(".ds-icon");

    $this.css({
      height: "",
    });

    $icon.removeClass("tw-translate-y-0.5 -tw-scale-y-100");

    $(".cart-preview__content, .cart-preview__footer").addClass("tw-hidden");
    $(".cart-preview-header").removeClass("cart-preview-header--open");
  });

  // Remove product from cart
  $(document).on("click", ".product-row__control-close", function (e) {
    e.preventDefault();

    var $this = $(this);
    var $id = $this.data("id");

    $.ajax({
      url: $this.data("route"),
      method: "GET",
      data: {
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      beforeSend: function () {},
      success: function (response) {
        if (response.success) {
          if (response.cart_total) {
            $(".cart-total").text(response.cart_total);
          }

          $(".cart-count").text(response.cart_count);

          if (response.overview) {
            $(".cart-preview__content").html(response.overview);
          }

          $(".cart-main").text(response.main);
          $(".cart-sub").text(response.sub);

          var container = $(".product-box__cart_" + $id);
          container.find(".tw-rounded-full").removeClass("tw-bg-ds-neutral-5/95 tw-shadow-md");
          container.find(".btn-decrease").addClass("tw-hidden");
          container.find(".tw-flex-1").addClass("tw-hidden");
          container.find('[data-tid="product-box__amount"]').val(0);
          updateAtcFeedbackChip($id, "");
        }
      },
      error: function (xhr) {
        if (xhr.responseJSON && xhr.responseJSON.message) {
          alert(xhr.responseJSON.message);
        } else if (xhr.status === 400) {
          alert("Unable to remove product from cart.");
        }
      },
    });
  });
});
